// State ======================
import lmsActions from "../api/LmsActions.js";
import lmsMutations from "../api/LmsMutations.js";
import lmsGetters from "../api/LmsGetters.js";
export const namespaced = true;

export const state = () => ({
  type: "lmsLessons",
  //pageLayout: "StructureTable",
  relations: [
    {
      name: "lmsBlocks",
      value: "lmsBlocks",
      translate: "blocks",
      export: false,
    },
    {
      name: "lmsCourse",
      value: "lmsCourses",
      translate: "courses",
      export: false,
    },
    {
      name: "lmsSection",
      value: "lmsSections",
      translate: "section",
      export: false,
    },
  ],
  all: {},
  reference: {},
  active: false,
  page: 1,
  pageCount: 0,
  pagination: {
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    itemsPerPage: 150,
    sort: true,
    sortBy: "name",
    page: 1,
    sortDesc: [],
  },
  total: 0,
  print: false,
  print_path: "",
  export: false,
  search: null,
  //this will need to by dynamic based on user config valuese
  bound: {},
  stub: {
    lmsCourse: {},
    lmsSection: {},
    lmsBlocks: [],
  },
  filter: {},
  //members are called contractors on the server
  include: [],
  headers: {},
  notifications: {},
});

// Mutations ==================

export const mutations = {
  ...lmsMutations,
};

// Actions ====================

export const actions = {
  ...lmsActions,
};

// Getters ====================

export const getters = {
  ...lmsGetters,
};
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
